<template>
    <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Lift Inspection Report" hide-footer :centered="true" v-model="open">
        <b-form class="pb-10">
            <gofix-form-dropdown
                label="Company Name & Address"
                vLabel="name"
                :append-to-body="true"
                :options="data.companies"
                v-model="dataSubmit.company">
                <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                    <span>{{ option.name }}</span>
                </template>
                <template slot="gofixInput:dropdown:option" slot-scope="option">
                    <div class="maintOption">
                        <p class="mb-0">{{ option.name }}</p>
                        <span class="d-block w-100" style="white-space: pre-wrap;" v-html="option.address"></span>
                    </div>
                </template>
            </gofix-form-dropdown>
            <gofix-form-dropdown
                label="Attention To"
                vLabel="name"
                :append-to-body="true"
                :options="data.attentions"
                v-model="dataSubmit.attention">
            </gofix-form-dropdown>
            <gofix-form-dropdown
                label="Reporter Name & Designation"
                :append-to-body="true"
                :options="data.reporters"
                v-model="dataSubmit.reporter">
                <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                    <span>{{ option.person_tc_name }}</span>
                </template>
                <template slot="gofixInput:dropdown:option" slot-scope="option">
                    <div class="maintOption">
                        <p class="mb-0">{{ option.person_tc_name }}</p>
                        <span v-html="option.description"></span>
                    </div>
                </template>
            </gofix-form-dropdown>
            <!-- <gofix-text-field class="mb-3" label="Lift Company" oneline>{{ supplier && supplier.id ? supplier.name : '--' }}</gofix-text-field> -->
            <gofix-form-dropdown
                label="Recipients"
                vLabel="name"
                append-to-body
                multiple
                :filterable="false"
                @search="searchContactableEmails"
                :options="emails"
                v-model="dataSubmit.emails" >
                <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                    <span>{{ option.name + ' - ' + option.email }}</span>
                </template>
                <template slot="gofixInput:dropdown:option" slot-scope="option">
                    <span>{{ option.name + ' - ' + option.email }}</span>
                </template>
            </gofix-form-dropdown>
        </b-form>
        <b-button-group class="d-block text-right">
            <gofix-button label="DOWNLOAD" @click="storeConfig(true)" noBorder></gofix-button>
            <gofix-button :disabled="hide_btn_report" label="REPORT" @click="storeConfig(false)" noBorder></gofix-button>
        </b-button-group>
    </b-modal>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: 'issue-register-detail',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        contract_id: {
            type: Number,
            default: 0
        },
        supplier: {
            type: Object,
            default: {}
        },
        eq_ids: {
            type: Array,
            default: []
        },
        hide_btn_report: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            open: false,
            data: {},
            dataSubmit: {
                company: null,
                attention: null,
                reporter: null,
                supplier_id: null,
                emails: null
            },
            emails: [],
            timer: null,
        }
    },
    watch: {
        value: function(val) {
            this.open = val;
            if(val) {
                this.dataSubmit = {
                    company: null,
                    attention: null,
                    reporter: null,
                    supplier_id: null,
                    emails: null
                }

                // this.getContactableEmails();
                // if(this.supplier && this.supplier.id) {
                //     this.dataSubmit.supplier_id = val.id
                // }
                this.getValueOfCustomField()
                if(this.data.reporters.length && this.UserLogin && this.UserLogin.id) {
                    const obj = this.data.reporters.find((item) => item.person_tc_name.toLowerCase() == this.UserLogin.name.toLowerCase());
                    if(obj) this.dataSubmit.reporter = obj;
                }
            }
        },
        open: function(val) {
            this.$emit('input', val);
        },
        contract_id: function(val) {
            this.getSettings()
        },
        "dataSubmit.company": function(val) {
            this.getLiftReportAntentions()
            this.getContactableEmails()
            this.dataSubmit.attention = null
            this.dataSubmit.emails = null
        },
        // supplier: function(val) {
        //     this.getContactableEmails();
        //     if(val && val.id) {
        //         this.dataSubmit.supplier_id = val.id
        //     }
        // },
    },
    computed: {
        ...mapGetters({
            UserLogin: "AuthController/user",
        })
    },
    created() {
        if(this.contract_id) {
            this.getSettings()
        }
    },
    methods: {
        getSettings() {
            this.$store.dispatch("LiftInspectionReportController/getSettingsForLiftInspectionReport", {
                contract_id: this.contract_id,
                report_type: 'Lift Inspection Report'
            })
            .then(result => {
                if(result) {
                    this.data = result;
                    this.data.attentions = [];
                    if(!this.data.reporters) this.data.reporters = [];
                    if(!this.data.companies) this.data.companies = [];
                    if(!this.data.contactables) this.data.contactables = [];
                } else {
                    this.data = {
                        company_name: '',
                        address: '',
                        person_name: '',
                        person_tc_name: '',
                        description: '',
                        contract_id: this.$route.params.id,
                        reference_id: this.report_types && this.report_types.length ? this.report_types[0].id : '',
                        reporters: [],
                        attentions: [],
                        companies: [],
                        contactables: []
                    };
                }
            }).catch(err => {
                console.log(err);
            });
        },
        storeConfig(is_download) {
            if(!this.dataSubmit.company) {
                return this.$alertNotification("Company is required", "danger");
            }
            if(!this.dataSubmit.attention) {
                return this.$alertNotification("Attention to is required", "danger");
            }
            if(!this.dataSubmit.reporter) {
                return this.$alertNotification("Reporter name and designation to is required", "danger");
            }

            if(!is_download && (!this.dataSubmit.emails || !this.dataSubmit.emails.length)) {
                return this.$alertNotification("Emails Lift Company is required", "danger");
            }

            let request = {
                config: {
                    company_name: this.dataSubmit.company.name,
                    address: this.dataSubmit.company.address,
                    attention: this.dataSubmit.attention.name,
                    reporter: this.dataSubmit.reporter,
                },
                supplier_id: this.dataSubmit.supplier_id,
                emails: this.dataSubmit.emails,
                is_download: is_download
            }
            this.$emit('report', request);
        },
        getLiftReportAntentions() {
            if(!this.data.id || !this.dataSubmit.company || !this.dataSubmit.company.id) return this.data.attentions = [];
            this.$store.dispatch("LiftInspectionReportController/getLiftReportAntentions", {
                report_config_id: this.data.id,
                report_company_id: this.dataSubmit.company.id
            })
            .then(result => {
                this.data.attentions = result;
            }).catch(err => {
                console.log(err);
            });
        },
        async getContactableEmails(search = '') {
            if(!this.data.id || !this.dataSubmit.company || !this.dataSubmit.company.id) return this.data.emails = [];
            await this.$store.dispatch("AllCompanyController/getContactableEmailsItems", {
                limit: -1,
                filter: {
                    search: search,
                    organisation_id: this.dataSubmit.company.id,
                    report_config_id: this.data.id,
                }
            })
            .then(result => {
                this.emails = result.items;
            }).catch(err => {
                console.log(err);
            });
        },
        searchContactableEmails(search, loading) {
            this.emails = []
            loading(true);
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(async () => {
                try {
                    await this.getContactableEmails(search);
                    await loading(false);
                } catch(err) {
                    await loading(false);
                }
            }, 500);
        },
        async getValueOfCustomField() {
            if(!this.eq_ids) return;
            await this.$store.dispatch("EquipmentV2Controller/getValueOfCustomField", {
                equipment_ids: this.eq_ids,
                attribute_column: 'name',
                attribute_value: 'Lift Company',
            })
            .then(result => {
                if(result && result.length) {
                    let companies = result.map(item => item.value.toLowerCase());
                    const obj = this.data.companies.find((item) => companies.includes(item.name.toLowerCase()));
                    if(obj) this.dataSubmit.company = obj;
                }
            }).catch(err => {
                console.log(err);
            });
            
        },
    }
}
</script>